import { ref, unref } from 'vue'

const isReactivationModalOpen = ref(false)
const isExpiredSubscription = ref(false)
const isCancelledSubscription = ref(false)
const reactivationAccommodationId = ref(null)
const reactivationSource = ref(null)
const isCancellationModalOpen = ref(false)
const cancellationAccommodationName = ref(null)
const cancellationAccommodationId = ref(null)
const cancellationProductType = ref(null)

export function useStudioPlusReactivation() {
  const openReactivationModal = (itemId, source = null) => {
    reactivationSource.value = source
    isReactivationModalOpen.value = true
    reactivationAccommodationId.value = unref(itemId)
  }

  const closeReactivationModal = () => {
    reactivationSource.value = null
    isReactivationModalOpen.value = false
    isExpiredSubscription.value = null
    isCancelledSubscription.value = null
  }

  const setIsExpired = endDate => {
    isExpiredSubscription.value = endDate ? new Date() > new Date(endDate) : false
  }

  const setIsCancelled = endDate => {
    const hasEndDate = endDate != null && endDate !== ''
    isCancelledSubscription.value = hasEndDate && !isExpiredSubscription.value
  }

  const openCancellationModal = itemData => {
    isCancellationModalOpen.value = true
    cancellationAccommodationName.value = itemData.accommodationName
    cancellationAccommodationId.value = itemData.accommodationId
    cancellationProductType.value = itemData.productType
  }

  const closeCancellationModal = () => {
    isCancellationModalOpen.value = false
    cancellationAccommodationName.value = null
    cancellationAccommodationId.value = null
    cancellationProductType.value = null
  }

  return {
    isReactivationModalOpen,
    isExpiredSubscription,
    isCancelledSubscription,
    reactivationAccommodationId,
    reactivationSource,
    isCancellationModalOpen,
    cancellationAccommodationName,
    cancellationAccommodationId,
    cancellationProductType,
    openReactivationModal,
    closeReactivationModal,
    setIsExpired,
    setIsCancelled,
    openCancellationModal,
    closeCancellationModal,
  }
}
